import { useNotifyFailedRequest } from '@Hooks/useNotifyFailedRequest';
import { useBillingRepository } from '@Hooks/useRepository';
import { PriceListPositionsRepository } from '@Repositories/Billing';
import { isOk, useToasts } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';

export function useAddServices(apiPriceListId: string) {
    const positions = useBillingRepository(PriceListPositionsRepository);
    const { pushToast, remove } = useToasts();
    const { notifyFailedRequest } = useNotifyFailedRequest({ title: 'Import', message: 'Import fehlgeschlagen.' });

    const addAllServicesMutation = useMutation({
        mutationFn: (serviceIds: string[] | undefined) => positions.addAllServices(serviceIds, apiPriceListId),
    });

    async function startAddServices(serviceIds: string[] | undefined) {
        const isRunningNotificationId = pushToast({
            message: 'Import läuft',
        });

        const addAllServicesResult = await addAllServicesMutation.mutateAsync(serviceIds);

        remove(isRunningNotificationId);

        if (isOk(addAllServicesResult)) {
            pushToast({
                title: 'Import',
                message: 'Import erfolgreich.',
                variant: 'success',
            });
        } else {
            notifyFailedRequest(addAllServicesResult);
        }

        return addAllServicesResult;
    }

    return {
        startAddAllMissingServices: () => startAddServices(undefined),
        startAddServices: (serviceIds: string[]) => startAddServices(serviceIds),
        isPending: addAllServicesMutation.isPending,
    };
}
